import {PlainDtoModel} from './plainDto.model';
import {PermissionsModel} from '../../permissions.model';
import {IWithPermissionModel} from '../../../permission/api/entity/iWithPermission.model';

export abstract class WithoutSummaryModel implements PlainDtoModel, IWithPermissionModel {
    permissions: PermissionsModel;
    id: number;
}
